import './home.scss';

import React from 'react';
import { Redirect, RouteComponentProps, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Row, Col, Alert } from 'reactstrap';

import { IRootState } from 'app/shared/reducers';
import { Translate, translate, getUrlParameter } from 'react-jhipster';
import LoginComponent from '../login/login-component';
import { login, eIdLogin, eIDAuthentication, loginToken, getSession } from 'app/shared/reducers/authentication';
import { getConfig } from 'app/shared/reducers/application-profile';

export interface IHomeProp extends StateProps, DispatchProps, RouteComponentProps<{}> {}

export interface IHomeState {
  type: String;
}

export class Home extends React.Component<IHomeProp> {
  state: IHomeState = {
    type: 'username'
  };

  componentWillMount() {
    const { isAuthenticated } = this.props;
    if (!isAuthenticated) {
      //this.eIDLogin();
    }
  }

  handleLoginToken = (certSerial, certBase64) => {
    this.props.loginToken(certSerial, certBase64);
  };

  handleLoginEID = (username, password, rememberMe = false) => {
    if (/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(username)) {
      this.setState({
        type: 'email'
      });
    } else if (/^[0]?[0-9]\d{9}$/.test(username)) {
      this.setState({
        type: 'phone'
      });
    } else {
      this.setState({
        type: 'username'
      });
    }
    this.props.eIdLogin(username, password, rememberMe, this.state.type);
  };

  handleAuthorizationEID = () => {
    // if (this.props.location.state.code) {
    //   alert(this.props.location.state.code);
    // }
  };

  eIDLogin = () => {
    window.location.href =
      this.props.config.urlAuth +
      '/oauth2/authorize?response_type=code&client_id=' +
      this.props.config.clientId +
      '&redirect_uri=' +
      (this.props.config.urlEid + '/login/callback').replace(':', '%3A').replace('/', '%2F') +
      '&scope=' +
      this.props.config.scope;
  };

  handleClose = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { account } = this.props;
    const { loginError } = this.props;
    window.location.href = this.props.config.urlEid + '/userprofile';

    return (
      <div>{/* {window['styleUserProfile']()} */}</div>
      // <Row>
      //   <Col md="12">
      //     <div className="mt-2">&nbsp;</div>
      //     {account && account.login ? (
      //       <div>
      //         <p className="lead">
      //           <Translate contentKey="home.subtitle">This is your homepage</Translate>
      //         </p>
      //         <Alert color="success">
      //           <Translate contentKey="home.logged.message" interpolate={{ username: account.login }}>
      //             You are logged in as user {account.login}.
      //           </Translate>
      //         </Alert>
      //       </div>
      //     ) : (
      //     <div>
      //       <Row md="12">
      //         <Col xs={7}>
      //           <div className="form-group">
      //             <div className="col-md-12">
      //               <span className="control-label">
      //                 <h4>
      //                   <b>VNConnect</b> là hệ thống xác thực và định danh điện tử với các tính năng nổi bật:
      //                 </h4>
      //               </span>
      //               <div>
      //                 <span className="glyphicon glyphicon-save" aria-hidden="true">
      //                   1. Lưu trữ dữ liệu tập trung.
      //                 </span>
      //               </div>
      //               <div>
      //                 <span className="control-label">2. Đăng nhập 1 lần trên tấp cả các hệ thống liên kết.</span>
      //               </div>

      //               <div>
      //                 <span className="control-label">3. Chia sẻ các thuộc tính dữ liệu với các hệ thống liên kết.</span>
      //               </div>
      //               <div className="mt-1">&nbsp;</div>
      //               <Alert color="warning">
      //                 Bạn cần&nbsp;
      //                 <Link to="/login" className="alert-link">
      //                   <Translate contentKey="global.messages.info.authenticated.link"> sign in</Translate>
      //                 </Link>
      //                 &nbsp;trước khi thực hiện thao tác với hệ thống!
      //               </Alert>

      //               <Alert color="warning">
      //                 <Translate contentKey="global.messages.info.register.noaccount">You do not have an account yet?</Translate>&nbsp;
      //                 <Link to="/register" className="alert-link">
      //                   <Translate contentKey="global.messages.info.register.link">Register a new account</Translate>
      //                 </Link>
      //               </Alert>
      //             </div>
      //           </div>
      //         </Col>

      //         <Col />
      //         <Col md="4">
      //           <LoginComponent
      //             handleLoginEID={this.handleLoginEID}
      //             handleAuthorizationEID={this.handleAuthorizationEID}
      //             handleClose={this.handleClose}
      //             loginError={this.props.loginError}
      //             handleLoginToken={this.handleLoginToken}
      //           />
      //         </Col>
      //       </Row>
      //     </div>
      //     )}
      //   </Col>
      // </Row>
    );
  }
}

const mapStateToProps = storeState => ({
  account: storeState.authentication.account,
  isAuthenticated: storeState.authentication.isAuthenticated,
  loginError: storeState.authentication.loginError,
  showModal: storeState.authentication.showModalLogin,
  config: storeState.applicationProfile.config
});

const mapDispatchToProps = { getSession, eIdLogin, eIDAuthentication, loginToken };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);
